import { useListSearch } from "@cmde/hooks";
import { useCallback, useState } from "react";

const DEFAULT_DEBOUNCE_DELAY = 300;

export function useAppListSearch<T>({
  data,
  keys,
  debounceDelay = DEFAULT_DEBOUNCE_DELAY,
  filterFn,
}: {
  data: T[];
  keys?: (keyof T | string)[];
  debounceDelay?: number;
  filterFn?: (item: T, query: string) => boolean;
}) {
  const [inputValue, setInputValue] = useState("");
  const { filteredData, query: debouncedQuery, setQuery } = useListSearch({
    data,
    keys,
    debounceDelay,
    filterFn,
  });

  const handleSearchChange = useCallback(
    (value: string) => {
      setInputValue(value);
      setQuery(value);
    },
    [setQuery],
  );

  return {
    inputValue,
    debouncedQuery,
    setInputValue: handleSearchChange,
    filteredData,
  };
}
